import React, { memo } from 'react'

import RichText from '../shared/text/RichText'
import { NFT_CONTENT_TYPE } from '../../constants/nft'

const NftExclusiveContent = ({
  staticExclusiveContent,
  dynamicExclusiveContent
}) => {
  if (dynamicExclusiveContent) {
    const { contentType, content } = dynamicExclusiveContent
    if (contentType === NFT_CONTENT_TYPE.HTML) {
      return <RichText isHTML content={content} />
    }
    return <RichText content={content} />
  }
  return <RichText content={staticExclusiveContent} />
}

export default memo(NftExclusiveContent)
